import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "action-section page-section" }
const _hoisted_2 = { class: "action-block" }
const _hoisted_3 = { class: "filter-checkboxes" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("legend", { class: "filter-text" }, " Assignment Type ", -1)
const _hoisted_5 = { class: "range-fields has-top-border" }
const _hoisted_6 = { class: "beige-bkg page-section flex-section" }
const _hoisted_7 = { class: "section-block" }
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<div class=\"title-row detailed-card\"><h1>Assignment Results</h1><div class=\"label-container\"><label class=\"card-label\">Term</label><div class=\"card-label dates\"><label class=\"card-label\">Release</label><label class=\"card-label\">Due</label></div></div></div>", 1)
const _hoisted_9 = {
  key: 0,
  class: "info-card beige"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", null, "No assignments match your filter criteria.", -1)
const _hoisted_11 = [
  _hoisted_10
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tandem_checkbox = _resolveComponent("tandem-checkbox")!
  const _component_tandem_date_input = _resolveComponent("tandem-date-input")!
  const _component_loading_indicator = _resolveComponent("loading-indicator")!
  const _component_info_card = _resolveComponent("info-card")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("fieldset", _hoisted_3, [
          _hoisted_4,
          _createVNode(_component_tandem_checkbox, {
            label: "Lesson",
            value: "Lesson",
            modelValue: _ctx.selectedTypes,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedTypes) = $event))
          }, null, 8, ["modelValue"]),
          _createVNode(_component_tandem_checkbox, {
            label: "Automated Lesson",
            value: "Automated Lesson",
            modelValue: _ctx.selectedTypes,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedTypes) = $event))
          }, null, 8, ["modelValue"]),
          _createVNode(_component_tandem_checkbox, {
            label: "Team Check",
            value: "Team Check",
            modelValue: _ctx.selectedTypes,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedTypes) = $event))
          }, null, 8, ["modelValue"]),
          _createVNode(_component_tandem_checkbox, {
            label: "Team Evaluation",
            value: "Team Evaluation",
            modelValue: _ctx.selectedTypes,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedTypes) = $event))
          }, null, 8, ["modelValue"]),
          _createVNode(_component_tandem_checkbox, {
            label: "One-Time Survey",
            value: "One-Time Survey",
            modelValue: _ctx.selectedTypes,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedTypes) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_tandem_date_input, {
            name: "publish-date",
            label: "From",
            defaults: { hour: 6, minute: 0 },
            modelValue: _ctx.after,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.after) = $event))
          }, null, 8, ["modelValue"]),
          _createVNode(_component_tandem_date_input, {
            name: "publish-date",
            label: "To",
            defaults: { hour: 6, minute: 0 },
            modelValue: _ctx.before,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.before) = $event))
          }, null, 8, ["modelValue"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        (_ctx.loading)
          ? (_openBlock(), _createBlock(_component_loading_indicator, { key: 0 }))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _hoisted_8,
              (!_ctx.selectedAssignments || !_ctx.selectedAssignments.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_11))
                : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.selectedAssignments, (assignment) => {
                    return (_openBlock(), _createBlock(_component_info_card, {
                      key: assignment.id,
                      title: assignment.title,
                      id: assignment.id,
                      "publish-date": assignment.publishDate,
                      "due-date": assignment.dueDate,
                      cohort: assignment.cohort
                    }, null, 8, ["title", "id", "publish-date", "due-date", "cohort"]))
                  }), 128))
            ], 64))
      ])
    ])
  ], 64))
}